// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Point } from './Point';
import {
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
    PointToJSONTyped,
} from './Point';

import { Address, AddressFromJSONTyped, AddressToJSON, AddressToJSONTyped } from './Address';
import { PointOfInterest, PointOfInterestFromJSONTyped, PointOfInterestToJSON, PointOfInterestToJSONTyped } from './PointOfInterest';
import { StopPlace, StopPlaceFromJSONTyped, StopPlaceToJSON, StopPlaceToJSONTyped } from './StopPlace';
/**
 * **Abstract Superclass** of concrete inherited sub-classes such as **`StopPlace`, `Address`, `PointOfInterest`**.
 * @export
 * @interface Place
 */
export interface Place {
    /**
     * Unique non-translated name of Place.
     * @type {string}
     * @memberof Place
     */
    name: string;
    /**
     * Unique id referable by underlying system(s).
     * @type {string}
     * @memberof Place
     */
    id: string;
    /**
     * The two uppercase character of ISO 3166 code, mostly similar to lowercase IANA identifier (source: DiDok geographic-based _isoCountryCode_).
     * @type {string}
     * @memberof Place
     */
    countryCode?: string;
    /**
     * In CH this represents the 'canton' abbreviation.
     * @type {string}
     * @memberof Place
     */
    canton?: string;
    /**
     * Specifies the distance in [m] to the given coordinates in request. (Only set for `v3/places/by-coordinates*`).
     * @type {number}
     * @memberof Place
     */
    distanceToSearchPosition?: number;
    /**
     * **Inheritance discriminator to proper Subclass** (technical field required by [OpenApi 3 Discriminator](https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/)) makes deserialization at consumer side easier.
     * @type {string}
     * @memberof Place
     */
    type: string;
    /**
     * 
     * @type {Point}
     * @memberof Place
     */
    centroid?: Point;
}

/**
 * Check if a given object implements the Place interface.
 */
export function instanceOfPlace(value: object): value is Place {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PlaceFromJSON(json: any): Place {
    return PlaceFromJSONTyped(json, false);
}

export function PlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Place {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'Address') {
            return AddressFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'PointOfInterest') {
            return PointOfInterestFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'StopPlace') {
            return StopPlaceFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'canton': json['canton'] == null ? undefined : json['canton'],
        'distanceToSearchPosition': json['distanceToSearchPosition'] == null ? undefined : json['distanceToSearchPosition'],
        'type': json['type'],
        'centroid': json['centroid'] == null ? undefined : PointFromJSON(json['centroid']),
    };
}

  export function PlaceToJSON(json: any): Place {
      return PlaceToJSONTyped(json, false);
  }

  export function PlaceToJSONTyped(value?: Place | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'Address':
                return AddressToJSONTyped(value as Address, ignoreDiscriminator);
            case 'PointOfInterest':
                return PointOfInterestToJSONTyped(value as PointOfInterest, ignoreDiscriminator);
            case 'StopPlace':
                return StopPlaceToJSONTyped(value as StopPlace, ignoreDiscriminator);
            default:
                throw new Error(`No variant of Place exists with 'type=${value['type']}'`);
        }
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
        'countryCode': value['countryCode'],
        'canton': value['canton'],
        'distanceToSearchPosition': value['distanceToSearchPosition'],
        'type': value['type'],
        'centroid': PointToJSON(value['centroid']),
    };
}

